@if (data.label) {
  <h4 class="h6">{{ data.label }}</h4>
}
@if (data.description) {
  <p>{{ data.description }}</p>
}

<div class="form-input-list-rows">
  @for (inputRow of inputRows; track $index; let rowIndex = $index, firstRow = $first) {
    <div class="form-input-list-row" [@rowAnimation] [formGroup]="getGroupControl(rowIndex)">
      @for (item of inputRow.items; track item) {
        <div class="form-input-wrapper">
          <ng-container [item]="item" uiDynamicInputItem [formControlName]="item.name"></ng-container>
          <!-- @todo CEP-4269 use ui-icon-button if missing configuration with buttonstyle="text" is available -->
          @if (!firstRow && $last) {
            <button
              (click)="removeRow(rowIndex)"
              [disabled]="inputRows.length === 1"
              mat-icon-button
              type="button"
              class="delete-button"
            >
              <ui-icon faName="trash" faStyle="light"></ui-icon>
            </button>
          }
        </div>
      }
    </div>
  }
</div>

<div class="form-input-list-footer">
  <!-- @todo CEP-4269 use ui-icon-button if missing configuration with buttonstyle="text" is available -->
  <ui-button
    class="add-button"
    buttonStyle="text"
    icon="circle-plus"
    iconStyle="light"
    (clicked)="addRow()"
  >
    {{ itemAddLabel }}
  </ui-button>
</div>
